export default "__VITE_ASSET__174dfa3c__"